import { useEffect } from "react"
import { containsValidTargetClass } from "./DatalayerMethods"
import useClickListener from "../../utils/hooks/useClickListener"

const DatalayerNavClick = props => {
  useEffect(() => {
    if (typeof window !== "undefined" && typeof document !== undefined) {
      // let x =
      //   null /* scoped like this b/c X will be set only when the top menu is selected but is needed for the subitems too */

      /* Due to the complexity of the mega menu dropdown items. We have to do this traversal and add attribute values. */
      // function addIndicesToSubMenuLeft() {
      const left_menus = document.querySelectorAll(
        ".ter-mega-menu__left-section"
      )
      left_menus.forEach(menu => {
        let items = menu.querySelectorAll("div.ter-mega-menu__left-title")
        items.forEach(function (item, index) {
          item.setAttribute("yValue", index + 1)
        })
      })
      // }
    }
  })

  const datalayerNavClickHandler = event => {
    const validClasses = [
      "ter-mobile-menu__link",
      "ter-mobile-mega-menu__name",
      "ter-mobile-mega-menu-category__single-link",
      "ter-mega-menu__nav-text",
      "ter-mega-menu__left-title",
      "ter-nav-mini-menu__drop-down__link",
      "ter-right-section__link",
      "ter-nav-mini-menu__text",
      "ter-navbar__nav-link",
      "ter-mobile-mega-menu-category__name",
      "ter-feature-section__link--underline",
      "t2-terra-text-link",
      "t2-site-navigation-main__nav-promo-link",
      "t2-site-navigation-main__subcategory-category-link",
      "t2-site-navigation-main__subcategory-link",
    ]
    if (containsValidTargetClass(validClasses, event?.target?.classList)) {
      const getNavIndex = (child, parent) => {
        return Array.prototype.indexOf.call(parent.children, child)
      }

      const isFeaturedLink =
        event?.target?.parentNode?.className?.includes(
          "ter-feature-section__link"
        ) ||
        event?.target?.className?.includes(
          "t2-site-navigation-main__nav-promo-link"
        ) ||
        event?.target?.parentNode?.className?.includes(
          "t2-site-navigation-main__nav-cta"
        )
          ? true
          : false

      let href = isFeaturedLink
        ? event?.target?.parentNode?.getAttribute("href")
        : event?.target?.getAttribute("href") || null
      let classes = event?.target?.getAttribute("class")

      let y,
        x = null

      let navLinkText =
        (event?.target?.textContent?.includes("caret")
          ? event?.target?.innerText
          : event?.target?.textContent) ||
        event?.target?.innerText ||
        event?.target?.getAttribute("title") ||
        event?.target?.getAttribute("alt") ||
        null

      let depth = event?.target?.getAttribute("data-depth") || null

      /* finding the x coordinate for the top menu (mega/mini) */
      if (
        classes?.includes("ter-mega-menu__nav-text") ||
        classes?.includes("ter-nav-mini-menu__text")
      ) {
        x = getNavIndex(
          event?.target?.parentNode,
          event?.target?.parentNode.parentNode
        )
        x = x + 1
        y = 0
      }

      /* Links with no dropdown menu */
      if (classes.includes("ter-navbar__nav-link")) {
        x = getNavIndex(event?.target, event?.target?.parentNode)
        x = x + 1
        y = 0
      }

      /* For the basic mini menu links */
      if (classes.includes("ter-nav-mini-menu__drop-down__link")) {
        y = getNavIndex(
          event?.target?.parentNode,
          event?.target?.parentNode.parentNode
        )
        y++
      }

      /* setting y coordinate for the mega menu dropdown items */
      if (classes.includes("ter-mega-menu__left-title")) {
        y = parseInt(event?.target?.getAttribute("yValue"))
      }

      let navPath = navLinkText
      if (
        event?.target?.classList.contains(
          "t2-site-navigation-main__subcategory-category-link"
        )
      ) {
        // second level item
        navPath =
          event?.target?.closest(".t2-site-navigation-main__megamenu")?.dataset
            ?.parentName +
          " > " +
          navLinkText
      } else if (
        event?.target?.classList?.contains(
          "t2-site-navigation-main__subcategory-link"
        )
      ) {
        // third level item
        navPath =
          event?.target
            ?.closest(".t2-site-navigation-main__subcategory")
            .querySelector(
              ".t2-site-navigation-main__subcategory > .t2-site-navigation-main__subcategory-title > span"
            ).textContent +
          " > " +
          event?.target?.closest(".t2-site-navigation-main__megamenu")?.dataset
            ?.parentName +
          " > " +
          event?.target?.querySelector(
            ".t2-site-navigation-main__subcategory-item-title"
          )?.childNodes[0]?.textContent
      }

      window.dataLayer.push({
        event: "nav_click",
        click_label: navLinkText, //label of navlink text
        click_url: href,
        nav_location: "header", //'header','footer','left'
        nav_level: depth,
        x: x,
        y: y,
        total_nav_levels: null, // not sure about how to fetch this.
        featured_link: isFeaturedLink,
        nav_path_english: navPath,
      })
    }
  }
  // add handler if relevant listener elem exists
  let query = ""
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    query =
      document?.querySelectorAll(
        ".ter-mobile-menu__link, .ter-mobile-mega-menu__name, .ter-mobile-mega-menu-category__single-link, .ter-mega-menu__nav-text, .ter-mega-menu__left-title, .ter-nav-mini-menu__drop-down__link, .ter-right-section__link, .ter-nav-mini-menu__text, .ter-navbar__nav-link, .t2-terra-text-link, .t2-site-navigation-main__nav-promo-link"
      ).length > 0
  }
  useClickListener(datalayerNavClickHandler, query)
}

export default DatalayerNavClick
